<template>
  <span id="networkspy" :class="currentClasses">
    <div></div>
  </span>
</template>

<script>
import internalBus from '@/internalBus'

export default {
  name: 'NetworkSpy',
  data () {
    return {
      active: 0
    }
  },
  computed: {
    currentClasses () {
      if (this.active > 0) {
        return 'loading'
      }
      return ''
    }
  },
  methods: {
    increment () {
      this.active += 1
    },
    decrement () {
      this.active -= 1
    },
    set (data) {
      if (typeof data === 'number') {
        this.active = data
      } else if (typeof data === 'object' && data.count !== undefined) {
        this.active = data.count
      } else {
        console.warn('NetworkSpy.set: what?', data)
      }
    }
  },
  mounted () {
    internalBus.$on('networkspy:increment', this.increment)
    internalBus.$on('networkspy:decrement', this.decrement)
    internalBus.$on('networkspy:set', this.set)
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#networkspy {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  z-index: 1000;

  div {
    opacity: 0;
    transition: opacity .15s ease-in-out;
    position: absolute;
    animation: 1s loading-bar .1s ease-in-out infinite;
    background-color: var(--orange);
    height: 100%;
    will-change: opacity, left, width;
  }

  &.loading div {
    opacity: 1;
    transition: opacity 150ms 150ms ease-in-out;
  }
}

@keyframes loading-bar {
  0% {
    left: 0;
    width: 0;
  }
  50% {
    left: 0;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 0;
  }
}

</style>
